/**
 * Verrou partagé entre onglets : une seule reconnexion CAS à la fois.
 * Chaque passage par le CAS remplace le cookie de session commun à tous les onglets,
 * deux connexions menées en parallèle s'écraseraient.
 */

export const cleVerrouReconnexion = "reconnexion_en_cours";

// Onglet de connexion fermé ou abandonné : le bouton redevient disponible après ce délai
const dureeVerrouReconnexionMs = 30 * 1000;

/**
 * Lit la fin du verrou posé par un onglet.
 * @returns {Number} Horodatage en ms, 0 si aucun verrou ou stockage indisponible.
 */
export function lireVerrouReconnexion() {
  try {
    return Number(localStorage.getItem(cleVerrouReconnexion)) || 0;
  } catch {
    return 0;
  }
}

/**
 * Pose le verrou pour la durée d'une reconnexion.
 * @returns {Number} Fin du verrou en ms (vaut pour cet onglet même si le stockage est indisponible).
 */
export function poserVerrouReconnexion() {
  const jusqua = Date.now() + dureeVerrouReconnexionMs;
  try {
    localStorage.setItem(cleVerrouReconnexion, String(jusqua));
  } catch {
    // Stockage indisponible : le verrou reste propre à cet onglet
  }
  return jusqua;
}

/**
 * Libère le verrou une fois la reconnexion aboutie.
 */
export function libererVerrouReconnexion() {
  try {
    localStorage.removeItem(cleVerrouReconnexion);
  } catch {
    // Stockage indisponible : le verrou expirera de lui-même
  }
}
